"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStrategyBuilderState = void 0;
var react_1 = require("react");
var ai_hub_strategy_api_service_1 = __importDefault(require("../../shared/services/ai-hub-strategy-api.service"));
var hooks_1 = require("../../shared/hooks");
var constants_1 = require("../../shared/constants");
var utils_1 = require("../../shared/utils");
var change_tracking_1 = require("../utils/change-tracking");
/**
 * Generic user-facing copy used when the underlying error is suppressed to
 * prevent server-side detail (stack traces, internal paths, DB column
 * names) from leaking into the UI. Detailed errors are still logged via
 * `console.warn` for diagnostics in non-production builds.
 */
var SAVE_FAILED_MESSAGE = 'Failed to save changes. Please try again.';
var INVALID_RESPONSE_MESSAGE = 'The server returned an invalid response. Please reload and try again.';
var LOAD_FAILED_MESSAGE = 'Could not load the selected strategy. Please reload and try again.';
/**
 * P2-1: gate any underlying-hook error string before it reaches the UI.
 * The hook may originate from a service layer that includes server stack
 * traces or internal paths in `error.message`; replace those with a
 * generic, user-safe sentinel.
 */
var sanitizeForDisplay = function (raw) {
    if (!raw)
        return '';
    return LOAD_FAILED_MESSAGE;
};
/**
 * Owns the full strategy builder editing lifecycle: strategies list +
 * structure load/save, draft tracking, debounced visualization input and
 * the inline strategy add/rename/delete name editor.
 *
 * Pure state container – the orchestrator wires the returned API to UI
 * sub-components without re-deriving anything itself.
 */
exports.useStrategyBuilderState = function (userEmail) {
    var _a = react_1.useState(null), selectedStrategyId = _a[0], setSelectedStrategyId = _a[1];
    var _b = hooks_1.useStrategies(), strategiesList = _b.data, isLoadingStrategies = _b.isLoading, strategiesCreatedAt = _b.createdAt, updateStrategies = _b.update, strategiesError = _b.error;
    // Pending list: local copy tracking uncommitted add/edit/delete changes
    var _c = react_1.useState([]), pendingStrategiesList = _c[0], setPendingStrategiesList = _c[1];
    var _d = hooks_1.useStrategyStructure(selectedStrategyId, pendingStrategiesList, strategiesCreatedAt), fetchedStructure = _d.data, structureError = _d.error, saveStructure = _d.save, isSaving = _d.isSaving, saveError = _d.saveError;
    var _e = react_1.useState([]), columns = _e[0], setColumns = _e[1];
    var _f = react_1.useState([]), savedColumns = _f[0], setSavedColumns = _f[1];
    var _g = react_1.useState([]), debouncedColumns = _g[0], setDebouncedColumns = _g[1];
    var _h = react_1.useState(false), isVisualizationLoading = _h[0], setIsVisualizationLoading = _h[1];
    var _j = react_1.useState(''), successMessage = _j[0], setSuccessMessage = _j[1];
    var _k = react_1.useState(''), errorMessage = _k[0], setErrorMessage = _k[1];
    var _l = react_1.useState(null), strategyEditMode = _l[0], setStrategyEditMode = _l[1];
    var _m = react_1.useState(''), strategyNameInput = _m[0], setStrategyNameInput = _m[1];
    // ── Sync fetched structure into local draft state ────────────────
    react_1.useEffect(function () {
        if (fetchedStructure.length > 0) {
            var cloned = utils_1.deepClone(fetchedStructure);
            setColumns(cloned);
            setSavedColumns(utils_1.deepClone(cloned));
            setDebouncedColumns(utils_1.deepClone(cloned));
        }
        else if (selectedStrategyId && fetchedStructure.length === 0) {
            setColumns([]);
            setSavedColumns([]);
            setDebouncedColumns([]);
        }
    }, [fetchedStructure, selectedStrategyId]);
    // ── Debounce visualization updates ───────────────────────────────
    react_1.useEffect(function () {
        var timer = setTimeout(function () {
            setDebouncedColumns(columns);
            setIsVisualizationLoading(false);
        }, constants_1.VISUALIZATION_DEBOUNCE_DELAY);
        return function () { return clearTimeout(timer); };
    }, [columns]);
    // ── Mirror server-side strategies list into pending list ─────────
    react_1.useEffect(function () {
        setPendingStrategiesList(utils_1.deepClone(strategiesList));
    }, [strategiesList]);
    // ── Derived ──────────────────────────────────────────────────────
    // P2-4: use a structural (key-sorted) compare for change detection so a
    // server round-trip that re-orders object keys does not produce phantom
    // "unsaved changes" — which would otherwise trigger spurious live-editing
    // presence broadcasts to other users.
    var hasStructureChanges = react_1.useMemo(function () { return change_tracking_1.stableStringify(columns) !== change_tracking_1.stableStringify(savedColumns); }, [columns, savedColumns]);
    var hasStrategyMetaChanges = react_1.useMemo(function () {
        return change_tracking_1.stableStringify(pendingStrategiesList.map(function (s) { return ({ id: s.id, name: s.name }); })) !==
            change_tracking_1.stableStringify(strategiesList.map(function (s) { return ({ id: s.id, name: s.name }); }));
    }, [pendingStrategiesList, strategiesList]);
    var hasUnsavedChanges = hasStructureChanges || hasStrategyMetaChanges;
    var isStrategyValid = !!selectedStrategyId && pendingStrategiesList.some(function (s) { return s.id === selectedStrategyId; });
    // ── Mutations ────────────────────────────────────────────────────
    var onColumnsChange = function (next) {
        setColumns(next);
        setIsVisualizationLoading(true);
    };
    var saveChanges = function () { return __awaiter(void 0, void 0, void 0, function () {
        var changeHistory, applyServerSnapshot, result_1, config, result, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setSuccessMessage('');
                    setErrorMessage('');
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    changeHistory = change_tracking_1.buildSaveChangeHistory(columns, savedColumns, pendingStrategiesList, strategiesList, selectedStrategyId, userEmail);
                    applyServerSnapshot = function (nextStrategies, nextCreatedAt, nextStructure) {
                        var clonedStrategies = utils_1.deepClone(nextStrategies);
                        updateStrategies(nextStrategies, nextCreatedAt);
                        setPendingStrategiesList(clonedStrategies);
                        if (nextStructure) {
                            var clonedStructure = utils_1.deepClone(nextStructure);
                            setSavedColumns(clonedStructure);
                            setColumns(utils_1.deepClone(clonedStructure));
                            setDebouncedColumns(utils_1.deepClone(clonedStructure));
                        }
                        setSuccessMessage('Changes saved successfully!');
                    };
                    if (!selectedStrategyId) return [3 /*break*/, 3];
                    return [4 /*yield*/, saveStructure(columns, pendingStrategiesList, changeHistory)];
                case 2:
                    result_1 = _b.sent();
                    if (result_1 === null) {
                        setErrorMessage(SAVE_FAILED_MESSAGE);
                        return [2 /*return*/];
                    }
                    // P1-3: never trust the API — validate the response shape before
                    // letting it reach editor state. A malformed payload (or a
                    // hostile node id of `__proto__` etc.) is rejected here, well
                    // before it can flow into `safeWriteEdge`.
                    if (!change_tracking_1.isStrategyColumnArray(result_1.structure) || !Array.isArray(result_1.allStrategies)) {
                        // eslint-disable-next-line no-console
                        console.warn('[StrategyBuilder] save returned an invalid structure shape');
                        setErrorMessage(INVALID_RESPONSE_MESSAGE);
                        return [2 /*return*/];
                    }
                    applyServerSnapshot(result_1.allStrategies, result_1.savedCreatedAt, result_1.structure);
                    return [2 /*return*/];
                case 3:
                    // No selected strategy — only persist if metadata (add / rename /
                    // delete) actually changed. Re-uses the memoized comparator to avoid
                    // duplicating the diffing logic.
                    if (!hasStrategyMetaChanges) {
                        return [2 /*return*/];
                    }
                    config = __assign({ strategies: pendingStrategiesList.map(function (s) { return (__assign(__assign({}, s), { structure: s.structure || [] })); }), changeHistory: changeHistory }, (strategiesCreatedAt ? { createdAt: strategiesCreatedAt } : {}));
                    return [4 /*yield*/, ai_hub_strategy_api_service_1.default.saveConfiguration(config)];
                case 4:
                    result = _b.sent();
                    // P1-3: validate boundary response on the meta-only save path too.
                    if (!change_tracking_1.isStrategiesConfigurationResponse(result)) {
                        // eslint-disable-next-line no-console
                        console.warn('[StrategyBuilder] meta save returned an invalid response');
                        setErrorMessage(INVALID_RESPONSE_MESSAGE);
                        return [2 /*return*/];
                    }
                    applyServerSnapshot(result.strategies, result.createdAt || null);
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _b.sent();
                    // P2-1: log the detail for diagnostics but show a generic message to
                    // avoid leaking server-side error text (stack traces, internal
                    // paths) into the user-visible MessageBar (OWASP A09).
                    // eslint-disable-next-line no-console
                    console.warn('[StrategyBuilder] save failed:', utils_1.getErrorMessage(error_1, 'unknown'));
                    // Boundary-validation failures from the API service are tagged so
                    // the user sees the more specific "invalid response" banner.
                    if ((_a = error_1) === null || _a === void 0 ? void 0 : _a.isInvalidResponse) {
                        setErrorMessage(INVALID_RESPONSE_MESSAGE);
                    }
                    else {
                        setErrorMessage(SAVE_FAILED_MESSAGE);
                    }
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var discardChanges = function () {
        var hasSelectedSavedStrategy = selectedStrategyId !== null && strategiesList.some(function (s) { return s.id === selectedStrategyId; });
        setPendingStrategiesList(utils_1.deepClone(strategiesList));
        if (hasSelectedSavedStrategy) {
            var restored = utils_1.deepClone(savedColumns);
            setColumns(restored);
            setDebouncedColumns(utils_1.deepClone(restored));
        }
        else {
            setSelectedStrategyId(null);
            setColumns([]);
            setSavedColumns([]);
            setDebouncedColumns([]);
        }
        setIsVisualizationLoading(false);
        setStrategyEditMode(null);
        setStrategyNameInput('');
        setSuccessMessage('');
        setErrorMessage('');
    };
    // ── Strategy name editor (local-only, persisted via Save Changes) ──
    var addStrategy = function () {
        var trimmedName = strategyNameInput.trim();
        if (!trimmedName)
            return;
        var nextId = pendingStrategiesList.length > 0
            ? Math.max.apply(Math, pendingStrategiesList.map(function (s) { return s.id; })) + 1
            : 1;
        var newStrategy = {
            id: nextId,
            name: trimmedName,
            structure: [],
        };
        setPendingStrategiesList(__spreadArrays(pendingStrategiesList, [newStrategy]));
        setStrategyEditMode(null);
        setStrategyNameInput('');
        setSelectedStrategyId(newStrategy.id);
    };
    var renameStrategy = function () {
        var trimmedName = strategyNameInput.trim();
        if (!trimmedName || !selectedStrategyId)
            return;
        setPendingStrategiesList(pendingStrategiesList.map(function (s) {
            return s.id === selectedStrategyId ? __assign(__assign({}, s), { name: trimmedName }) : s;
        }));
        setStrategyEditMode(null);
        setStrategyNameInput('');
    };
    var deleteStrategy = function () {
        if (!selectedStrategyId)
            return;
        setPendingStrategiesList(pendingStrategiesList.filter(function (s) { return s.id !== selectedStrategyId; }));
        setSelectedStrategyId(null);
    };
    // P2-1: combine all error sources into a single sanitized field. The
    // orchestrator's local `errorMessage` is already user-safe (we set it
    // ourselves); the hook errors are passed through `sanitizeForDisplay`.
    var displayError = errorMessage ||
        sanitizeForDisplay(strategiesError) ||
        sanitizeForDisplay(structureError) ||
        sanitizeForDisplay(saveError);
    // P2-1: surface a dedicated flag for load failures so the UI can
    // disable mutating actions (Add strategy) without re-parsing the
    // sanitized display string.
    var hasLoadError = !!(strategiesError || structureError);
    var dismissError = function () {
        setErrorMessage('');
    };
    var dismissSuccess = function () {
        setSuccessMessage('');
    };
    return {
        selectedStrategyId: selectedStrategyId,
        setSelectedStrategyId: setSelectedStrategyId,
        isStrategyValid: isStrategyValid,
        strategiesList: strategiesList,
        pendingStrategiesList: pendingStrategiesList,
        isLoadingStrategies: isLoadingStrategies,
        columns: columns,
        debouncedColumns: debouncedColumns,
        isVisualizationLoading: isVisualizationLoading,
        onColumnsChange: onColumnsChange,
        isSaving: isSaving,
        hasUnsavedChanges: hasUnsavedChanges,
        successMessage: successMessage,
        displayError: displayError,
        hasLoadError: hasLoadError,
        dismissError: dismissError,
        dismissSuccess: dismissSuccess,
        saveChanges: saveChanges,
        discardChanges: discardChanges,
        strategyEditMode: strategyEditMode,
        setStrategyEditMode: setStrategyEditMode,
        strategyNameInput: strategyNameInput,
        setStrategyNameInput: setStrategyNameInput,
        addStrategy: addStrategy,
        renameStrategy: renameStrategy,
        deleteStrategy: deleteStrategy,
    };
};
